/**
 * An error to throw from within the ActionCreator functions
 */
export class InvalidActionStateError extends Error {
  userMessage: string | "SUPPRESS";
  userHint?: string;
  underlyingError?: Error;
  errorData?: any;

  static get defaultUserMessage() {
    return "Something went wrong. Please try again.";
  }

  constructor(
    messageOrError: string | Error | any,
    args?: {
      userMessage?: string | "SUPPRESS";
      userHint?: string;
      errorData?: any;
    },
  ) {
    if (typeof messageOrError === "string") {
      super(messageOrError);
    } else {
      const underlyingError = messageOrError as Error;

      super(underlyingError.message);

      this.underlyingError = underlyingError;
    }

    this.userMessage = args?.userMessage ?? InvalidActionStateError.defaultUserMessage;
    this.userHint = args?.userHint;
    this.errorData = args?.errorData;
  }
}
